export default {"src":"/_next/static/media/closeIcon.2cacc738.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};